import { Button, Text } from '@chakra-ui/react';
import { Link } from '~components/ui/Link';
import { Page } from '~components/ui/Page';
import { PageContent } from '~components/ui/PageContent';

export function PlaylistNotFoundPage() {
  return (
    <Page title="404" pageName="playlist_404" analyticsDisableTracking={true}>
      <PageContent maxWidth="300px" textAlign="center">
        <Text fontWeight="semibold" color="gray.600">
          This playlist does not exist, or you don&apos;t have permissions to view it.
        </Text>

        <Text marginTop="8" fontSize="sm">
          Try to select another playlist on the{' '}
          <Button as={Link} variant="link" size="sm" colorScheme="blue" to="../">
            playlists overview page.
          </Button>
        </Text>
      </PageContent>
    </Page>
  );
}
